/**
 * Путь сайта на языке текущей страницы: `'/register'` → `'/es/register'`.
 *
 * Префикс приходит из `window.App.localePrefix` (layouts/main.blade.php): тот,
 * под которым открыта страница — `'/es'`, `'/zh-hans'`; пусто у дефолтного языка
 * и у языков на поддомене (en.testometrika.com), там пути остаются от корня.
 *
 * @param path путь от корня сайта; абсолютные URL, `//host` и уже
 *             локализованный путь возвращаются как есть.
 */
export default function localizePath(path: string): string {
	const prefix = window.App?.localePrefix ?? '';

	if (
		!prefix ||
		!path.startsWith('/') ||
		path.startsWith('//') ||
		path === prefix ||
		path.startsWith(`${prefix}/`)
	) {
		return path;
	}

	return `${prefix}${path}`;
}
